module.exports = __webpack_public_path__ + "img/allianz.9f1ccfac.jpg";